// generated from 149 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceModelFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_model_filter"),
  comparison_key: z.enum([
    "1", // 39 (26.17%)
    "11", // 27 (18.12%)
    "27", // 21 (14.09%)
    "2", // 20 (13.42%)
    "10", // 14 (9.40%)
    "26", // 7 (4.70%)
    "17", // 7 (4.70%)
    "25", // 6 (4.03%)
    "12", // 6 (4.03%)
    "28", // 2 (1.34%)
  ]),
  display_name: z.string(),
  // undefined: 43 (28.86%), defined 106 (71.14%)
  raw_value: z
    .union([
      // string samples: 78 (73.58%)
      z.string(),
      // array samples: 28 (26.42%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // string samples: 113 (75.84%)
    z.string(),
    // array samples: 36 (24.16%)
    z.array(z.string()),
  ]),
  varies_by_app_group: z.literal(false),
});
